var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup401(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -.153)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 75,
    r: 75,
    fill: "#f4f7f2",
    transform: "translate(0 .153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#486a41",
    d: "M58.363 14.564l-6.927-6.928a2.578 2.578 0 1 0-3.646 3.646l1.641 1.641-3.365 3.365a27.835 27.835 0 0 0-15.387-6.373V5.156H33A2.578 2.578 0 0 0 33 0h-9.8a2.578 2.578 0 1 0 0 5.156h2.32v4.759a28.1 28.1 0 1 0 24.192 10.019l3.365-3.365 1.641 1.641a2.578 2.578 0 0 0 3.646-3.646zM28.1 60.843A22.945 22.945 0 1 1 51.047 37.9 22.971 22.971 0 0 1 28.1 60.843zM41.5 37.9a2.578 2.578 0 0 1-2.578 2.578H28.1a2.578 2.578 0 0 1-2.577-2.578V22.729a2.578 2.578 0 0 1 5.156 0V35.32h8.24A2.578 2.578 0 0 1 41.5 37.9z",
    transform: "rotate(-8 338.385 -230.482)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#486a41",
    fontFamily: "Belleza-Regular, Belleza",
    fontSize: "63px",
    transform: "rotate(14.98 -292.4 390.77)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "!")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup401);
export default __webpack_public_path__ + "static/media/Group 401.349aa4e788535587ab102d1554b52bdc.svg";
export { ForwardRef as ReactComponent };